'use client'

import { useLocale, useTranslations } from 'next-intl'
import { useRef } from 'react'

import { MAX_USING_FEE, MIN_USING_FEE } from '@/entities/map'
import { Button, Slider } from '@/shared/ui'

import {
  ENGLISH_USING_FEE_VALUE_FORMAT,
  USING_FEE_VALUE_FORMAT,
} from './value-format'
import { Description, Title } from '../../common/layout'

type Props = {
  ref: (element: HTMLDivElement) => void
  value: number[]
  onValueChange: (value: number[]) => void
  className?: string
}

export const UsingFeeInDefaultView = ({
  ref,
  value,
  onValueChange,
  className,
}: Props) => {
  const locale = useLocale()
  const isEnglish = locale === 'en'

  const t = useTranslations('filter')

  const rangeRef = useRef<number[]>(value)

  const handleValueChange = (value: number[]) => {
    rangeRef.current = value
  }

  const handleApplyButtonClick = () => {
    onValueChange(rangeRef.current)
  }

  return (
    <div className={className} ref={ref}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Title className="mb-0">{t('price.title')}</Title>
          <Description>{t('price_subtitle')}</Description>
        </div>
      </div>
      <Slider.Root
        value={value}
        onValueChange={handleValueChange}
        min={MIN_USING_FEE}
        max={MAX_USING_FEE}
        step={50000}
        minStepsBetweenThumbs={1}
        valueFormat={
          isEnglish ? ENGLISH_USING_FEE_VALUE_FORMAT : USING_FEE_VALUE_FORMAT
        }
        className="space-y-1"
      >
        <Slider.Track />
        <div className="flex gap-2">
          <Slider.RangeInput
            size="small"
            {...(isEnglish && {
              inputClassName: 'gap-0 *:text-start',
              padding: {
                x: 4,
                y: 9,
              },
            })}
          />
          <Button
            size="medium"
            className="w-12.5 shrink-0"
            onClick={handleApplyButtonClick}
          >
            {t('price_apply')}
          </Button>
        </div>
      </Slider.Root>
    </div>
  )
}
